import { render, staticRenderFns } from "./markAsShipped.vue?vue&type=template&id=92c38c92"
import script from "./markAsShipped.vue?vue&type=script&lang=js"
export * from "./markAsShipped.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports